var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.137,
    height: 131.569,
    viewBox: "0 0 113.137 131.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6379.432 -40.431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0a40,40,0,0,1,0,80L3.536,76.464,0,40A40,40,0,0,1,40,0Z",
    transform: "translate(6379.432 97) rotate(-45)",
    fill: "#ff4261"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6359.002 35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.892,54.63c-.271,3.651-3.039,6.63-6.077,6.63s-5.811-2.978-6.077-6.63a6.1,6.1,0,1,1,12.154,0Z",
    transform: "translate(-96.558)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.257,304c-6.008,0-12.106,3.315-13.234,9.572a1.16,1.16,0,0,0,1.08,1.478H89.411a1.16,1.16,0,0,0,1.081-1.478C89.363,307.315,83.265,304,77.257,304Z",
    transform: "translate(0 -238.321)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6427 154)",
    fill: "#fff",
    stroke: "#ff4261",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMarker);
export default __webpack_public_path__ + "static/media/userMarker.8efea5d2ac8eaeb75eddff81706a8970.svg";
export { ForwardRef as ReactComponent };